import fetchApi from 'services/fetch';
import { boAPI } from 'constants/api';
import { track, generateServerResponseError, generateMessageDisplayedSegment } from 'utils/segmenTracker';
import { ACTIVATION, SERVER_RESPONSE_FAILED, MESSAGE_DISPLAYED } from 'constants/segmentEvents';

const initialState = {
  location: {},
  locationsData: {},
};

export const inputAddress = {
  state: { ...initialState },
  reducers: {
    updateLocation(state, payload) {
      return { ...state, location: payload };
    },
    updateLocationData(state, payload) {
      return { ...state, locationsData: { ...state.locationsData, ...payload } };
    },
    clearStore() {
      return { ...initialState };
    },
  },
  effects: (dispatch) => {
    return {
      async getBuildingsData(params, state) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'GET',
          url: boAPI.getLocations.replace(':id', state?.locationDetails?.coverage?.nodeid),
          params,
        })
          .then((response) => {
            const data = response.data;
            dispatch.apiStatus.setProcessing(false);
            if (Array.isArray(data) && data.length) this.updateLocationData({ buildings: data });
            else this.updateLocationData({ buildings: [] });
          })
          .catch((error) => {
            dispatch.apiStatus.setProcessing(false);
            track(SERVER_RESPONSE_FAILED, {
              ...generateServerResponseError(
                error,
                ACTIVATION,
                'Address List',
                boAPI.getLocations.replace(':id', state?.locationDetails?.coverage?.nodeid),
                'Get Address List API'
              ),
            });
            track(MESSAGE_DISPLAYED, {
              ...generateMessageDisplayedSegment(error, ACTIVATION, 'Get Address List API'),
            });
            return Promise.resolve({ success: false });
          });
      },
    };
  },
};
